import { useOutletContext } from 'react-router-dom';
import { ErrorPageLayout, PaperLayout } from '../../../../presentation';
import { QuotesEntityPageContainer } from '../quotes-entity.page.container';
import { GetQuoteQuery } from '@converge/graphql';
import './quote.detail.submissions.scss';
import { Typography } from '@mui/material';

interface IProps {
  quoteDetails: GetQuoteQuery;
  quoteUuid: string;
}

export const QuotesDetailSubmissions = () => {
  const { quoteDetails } = useOutletContext<IProps>();
  if (!quoteDetails) {
    return (
      <ErrorPageLayout
        message="No Quote data found"
        messageId="entity.quote.detail.page.NotFound"
      />
    );
  }

  return <QuoteDetailSubmissionsInner />;
};

const QuoteDetailSubmissionsInner = () => {
  return (
    <QuotesEntityPageContainer title="Submissions">
      <PaperLayout className="quote-detail-submission-layout">
        <Typography>To be implemented</Typography>
      </PaperLayout>
    </QuotesEntityPageContainer>
  );
};
